"use strict";
// NiceIntersection<S, T> type is equivalent to a plain intersection type S & T
// except it makes the result look like {foo: ..., bar?: ...} instead of {foo: ...} & {bar?: ...}.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=nice-intersection.js.map